module.exports = __webpack_public_path__ + "img/aboutPage_service_icon11.99d776cf.png";